import Tingyun from "@tingyun-sdk/web";

export const initTy = (config?: any) => { 
  if (/(localhost)/.test(window.location.hostname)) return;
  if (config?.switch) {
    Tingyun.init(tyConfig(config));    
  } else {
    console.log('load Tingyun switch off==');
  }
}

const tyConfig = (config?: any) => { 
  return {
    "domain":`${config?.domain}`,
    "token":`${config?.token}`,
    "key":`${config?.key}`,
    "id":`${config?.id}`,
    "plugins":[
      "TingyunPluginRecord"
    ],
    "page":{
      "drThreshold":5000,
      "fpThreshold":3000
    },
    "operation":{
      "rageClickEnabled":false
    },
    "requestTracing":{
      "corsDomains":[
        "static-le.shanghaidisneyresort.com",
        "static.shanghaidisneyresort.com",
        "latest-cu.apigw.shanghaidisneyresort.com",
        "stage-cu.apigw.shanghaidisneyresort.com",
        "sl-cu.apigw.shanghaidisneyresort.com",
        "cu.apigw.shanghaidisneyresort.com"
      ]
    },
    "replay":{
      "sampleRate":0.1
    }
  };
}